import { render, staticRenderFns } from "./myResourceStoreManageList.vue?vue&type=template&id=8a9296fc&scoped=true"
import script from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
export * from "./myResourceStoreManageList.vue?vue&type=script&lang=js"
import style0 from "./myResourceStoreManageList.vue?vue&type=style&index=0&id=8a9296fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9296fc",
  null
  
)

export default component.exports